import React from 'react';
import { Phone } from 'lucide-react';

interface ContactSectionProps {
  onContactClick: () => void;
}

const ContactSection: React.FC<ContactSectionProps> = ({ onContactClick }) => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4 text-primary-900">
            Ready to Partner? Have a Site to Discuss?
          </h2>
          <p className="text-gray-600 mb-8">
            Let's talk about your next opportunity. Whether you're a landowner, investor, or planning consultant, 
            we'd love to hear from you.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={onContactClick}
              className="px-8 py-4 bg-primary-800 text-white font-medium rounded-md hover:bg-primary-700 transition-colors duration-300 text-lg inline-flex items-center justify-center"
            >
              Start the Conversation
            </button>
            <a
              href="tel:+441234567890"
              className="px-8 py-4 bg-gray-100 text-primary-800 font-medium rounded-md hover:bg-gray-200 transition-colors duration-300 text-lg inline-flex items-center justify-center"
            >
              <Phone className="w-5 h-5 mr-2" />
              Call Us Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;